import {getPrivateAxios} from '@blesk-frontend/api';

export interface BillingFreeLimits {
  current: number;
  limit: number;
}

export const fetchBillingFreeLimits = async () => {
  const {data} = await getPrivateAxios().get<BillingFreeLimits | null>('/billing/free-limits');
  return data;
};
